import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SharedAuthSessionManager, SharedAuthSessionOptions, SharedInvalidSessionHandler } from '@share-auth-session';
import { AuthSessionService } from './auth-session.service';
import { AppState } from '../store/app.state';
import { AuthenticationActions } from '@states/authentication/authentication.action-types';

@Injectable({
  providedIn: 'root',
})
export class WebSharedAuthSessionManager implements SharedAuthSessionManager {
  constructor(private authSessionService: AuthSessionService) {}

  public ensureValidSession(options: SharedAuthSessionOptions): Promise<boolean> {
    return this.authSessionService.ensureValidSession(options);
  }
}

@Injectable({
  providedIn: 'root',
})
export class WebInvalidSessionHandler implements SharedInvalidSessionHandler {
  private logoutDispatched = false;

  constructor(private store$: Store<AppState>) {}

  public handleInvalidSession(): void {
    if (this.logoutDispatched) {
      return;
    }

    this.logoutDispatched = true;
    this.store$.dispatch(AuthenticationActions.Logout({
      params: {
        msg: 'Session is invalid',
        publicLogout: true,
      },
    }));
  }
}
